import { render, staticRenderFns } from "./TreatmentDetails.vue?vue&type=template&id=a4018714&scoped=true"
import script from "./TreatmentDetails.vue?vue&type=script&lang=js"
export * from "./TreatmentDetails.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDetails.vue?vue&type=style&index=0&id=a4018714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4018714",
  null
  
)

export default component.exports